export default __webpack_public_path__ + "static/media/rw-8h.5db05432.png";